import { AllowanceTypes } from "@Shared/Entities/Supplier/Response/Proposal/enums";
const overrides = {
    [AllowanceTypes["Std SMS"]]: "Standard SMS",
    [AllowanceTypes["Prem SMS"]]: "Premium SMS",
    [AllowanceTypes["Biz rate Calls (mins)"]]: "Business Rate Calls per Min",
    [AllowanceTypes["Prem Calls"]]: "Premium Rate Calls per Min",
    [AllowanceTypes["UK IDD to ROW (mins)"]]: "UK to Rest of World per Min",
    [AllowanceTypes["UK IDD to USA & Canada (mins)"]]: "UK IDD to USA & Canada per Min",
    [AllowanceTypes["UK IDD to APAC (mins)"]]: "UK IDD to APAC per Min",
    [AllowanceTypes["UK IDD to Everywhere (mins)"]]: "UK IDD to Everywhere per Min",
};
export const displayAllowanceType = (allowanceType) => {
    return overrides[allowanceType] || allowanceType;
};
